import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

class Badge extends Component {
    render() {
        const { children, style } = this.props;

        return <View style={[styles.container, style]}>{children}</View>;
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.transparent,
        paddingHorizontal: Layout.gutterMin,
        paddingVertical: Layout.gutterMin,
        borderRadius: Layout.gutterMin,
        alignItems: 'center'
    }
});

export default Badge;
